// extracted by mini-css-extract-plugin
module.exports = {"loaderOuter":"_1gilZ","bottomContainer":"_1bsQX","bottomText":"_1MWNH"};